enum UserRole {
    // [default] Role, assigned by default
    GHOST = 'ghost',

    // [core] Root
    CORE_ROOT = 'core.root',

    // [core] Admin
    CORE_ADMIN = 'core.admin',

    // [core] Platform Dev
    CORE_PLATFORM_DEV = 'core.platform_dev',

    // [core] Operations Manager
    CORE_OPERATIONS_MANAGER = 'core.operations_manager',

    // [core] Operations Manager
    CORE_ACCOUNT_DIRECTOR = 'core.account_director',

    // [core] Operations Manager
    CORE_CREATIVE_DIRECTOR = 'core.creative_director',

    // [core] Account Manager
    CORE_ACCOUNT_MANAGER = 'core.account_manager',

    // [core] HR
    CORE_HR = 'core.hr',

    // [core] Project Manager
    CORE_PROJECT_MANAGER = 'core.project_manager',

    // [core] Art Director
    CORE_ART_DIRECTOR = 'core.art_director',

    // [core] Assistant Art Director
    CORE_ASSISTANT_ART_DIRECTOR = 'core.assistant_art_director',

    // [core] Designer
    CORE_DESIGNER = 'core.designer',

    // [client] DotYeti client
    CLIENT_STANDALONE = 'client.standalone',

    // [workspace] Workspace admin
    WORKSPACE_ADMIN = 'workspace.admin',

    // [workspace] Workspace member
    WORKSPACE_MEMBER = 'workspace.member',
}

export default UserRole;
